import Vue from "vue";
import VueRouter from "vue-router";
import login from "@/views/login.vue";
import Home from "@/views/homePage.vue";
import AiPoster from "@/views/aiPoster/index.vue";
import GeneratedPosterPage from "@/views/aiPoster/GeneratedPosterPage.vue";
import AiText from "@/views/aiText/index.vue";
import aiTextDetail from "@/views/aiText/aiTextDetail.vue";
import AiVideo from "@/views/aiVideo/index.vue";
import CustomAvatar from "@/views/aiVideo/customAvatar/index.vue";
import RecordingGuide from "@/views/aiVideo/customAvatar/recordingGuide.vue";
import AuthorizedVideo from "@/views/aiVideo/customAvatar/authorizedVideo.vue";
import CustomVoice from "@/views/aiVideo/customAvatar/customVoice.vue";
import MyFigure from "@/views/aiVideo/customAvatar/myFigure.vue";
import CreationDetail from "@/views/aiVideo/customAvatar/creationDetail.vue";
import FreeShooting from "@/views/aiVideo/customAvatar/freeShooting.vue";
import UploadVideo from "@/views/aiVideo/customAvatar/uploadVideo.vue";
import Bestseller from "@/views/aiVideo/customAvatar/bestseller.vue";
import VideoCreation from "@/views/aiVideo/customAvatar/videoCreation.vue";

import videoText from "@/views/aiVideo/videoText/index.vue";
import videoTextconfirm from "@/views/aiVideo/videoText/confirm.vue";
import videoTextrewrite from "@/views/aiVideo/videoText/rewrite.vue";
import videoTextcreate from "@/views/aiVideo/videoText/create.vue";
// import { Toast } from "vant";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    component: login,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "",
      title: "登录",
    },
  },
  {
    path: "/home",
    component: Home,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "",
      title: "营销文案",
    },
  },
  {
    path: "/aiPoster",
    component: AiPoster,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "AI海报",
    },
  },
  {
    path: "/GeneratedPosterPage",
    component: GeneratedPosterPage,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "海报生成",
    },
  },
  {
    path: "/aiText",
    component: AiText,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "AI笔记",
    },
  },
  {
    path: "/aiTextDetail",
    component: aiTextDetail,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "生成结果",
    },
  },
  {
    path: "/aiVideo",
    component: AiVideo,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "AI视频",
    },
  },
  {
    path: "/customAvatar",
    component: CustomAvatar,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "形象定制",
    },
  },
  {
    path: "/recordingGuide",
    component: RecordingGuide,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "拍摄教程",
    },
  },
  {
    path: "/authorizedVideo",
    component: AuthorizedVideo,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "授权视频",
    },
  },
  {
    path: "/customVoice",
    component: CustomVoice,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "声音定制",
    },
  },
  {
    path: "/myFigure",
    component: MyFigure,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "我的形象",
    },
  },
  {
    path: "/creationDetail",
    component: CreationDetail,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "我的创作-详情",
    },
  },
  {
    path: "/freeShooting",
    component: FreeShooting,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "自由拍摄",
    },
  },
  {
    path: "/uploadVideo",
    component: UploadVideo,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "上传视频",
    },
  },
  {
    path: "/bestseller",
    component: Bestseller,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "爆款跟拍",
    },
  },
  {
    path: "/videoText",
    component: videoText,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "脚本创作",
    },
  },
  {
    path: "/videoTextcreate",
    component: videoTextcreate,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "脚本创作",
    },
  },
  {
    path: "/videoTextrewrite",
    component: videoTextrewrite,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "脚本创作",
    },
  },
  {
    path: "/videoTextconfirm",
    component: videoTextconfirm,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#f5f6f8",
      title: "脚本创作",
    },
  },
  {
    path: "/videoCreation",
    component: VideoCreation,
    meta: {
      showTabbar: false,
      showHeader: false,
      backgroundColor: "#ffffff",
      title: "视频创作",
    },
  },
];

const router = new VueRouter({
  mode: "hash", // 或 history（需服务端支持）
  routes,
});

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("token");
  //没有登录token可以访问的页面
  const whiteList = ["/", "/login"];
  //为登录且不是进入登录页时自动跳转至登录页
  if (!token) {
    if (!whiteList.includes(to.path)) {
      // Toast("请先登录后再访问");
      return next({ path: "/", replace: true });
    }
    return next();
  }
  // 1. 判断条件
  if (
    (to.path === "/recordingGuide" &&
      from.path === "/customAvatar" &&
      !from.query.formPath &&
      !sessionStorage.getItem("goPage")) ||
    (to.path === "/customAvatar" &&
      from.path === "/videoCreation" &&
      !sessionStorage.getItem("formPage")) ||
    (to.path === "/customAvatar" &&
      from.path === "/myFigure" &&
      !sessionStorage.getItem("formPage"))
  ) {
    console.log("拦截跳转，执行回退");
    if (window.history.length > 2) {
      window.history.go(-2);
      return;
    } else {
      return next({ path: "/home", replace: true });
    }
  }
  // 5. 其他情况正常放行
  next();
});
export default router;
